import React from "react";
import DepositAlternative from "./DepositAlternative";
import DeferDocumentUpload from "./DeferDocumentUpload";
import { Button } from "../styles/Button.styled";
import { useTranslation } from "react-i18next";
import qs from "qs";
import { useLocation } from "react-router";

const DepositWaiverWelcomeScreen = ({ footer, enrollmentTokens }) => {
  const { t } = useTranslation("enrollment");
  const location = useLocation();
  // get id from the params
  let { id } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const [modelContent, setModelContent] = React.useState({
    id: "initial-screen",
    title: t("Alternatives to Paying a Deposit"),
    component: <DepositAlternative />,
  });

  return (
    <div>
      <h1 className="my-4 text-center">{modelContent.title}</h1>
      {modelContent.component}
      {modelContent.id === "initial-screen" && (
        <div style={{ display: "flex", justifyContent: "center", gap: 20 }}>
          <>
            <Button
              style={{
                marginRight: "1rem",
                background: "transparent",
                color: "#253f66",
              }}
              onClick={() => {
                setModelContent({
                  id: "deposit-alternative-screen",
                  title: t("Defer Deposit Waiver Document Upload"),
                  component: (
                    <DeferDocumentUpload
                      setModelContent={setModelContent}
                      enrollmentId={enrollmentTokens?.enrollment_id || id}
                    />
                  ),
                });
              }}
            >
              {t("deferDocumentUpload")}
            </Button>
            {footer()}
          </>
        </div>
      )}
    </div>
  );
};

export default DepositWaiverWelcomeScreen;
